import type { External } from '@quromedical/models';
import { CrudForm } from 'components/form';
import type { Field } from 'components/types';
import type { FormikErrors } from 'formik';
import type React from 'react';
import { useCallback } from 'react';
import { strings } from 'strings';

interface PractitionerExternalFormProps {
  onValidChange: (data?: External) => void;
  showErrors: boolean;
}

export const createExternalFields = (): Field<External>[] => {
  return [
    {
      subfields: [
        {
          key: 'ampathMnemonic',
          label: strings.AmpathMnemonic,
          type: 'text-box',
        },
      ],
    },
  ];
};

export const PractitionerExternalForm: React.FC<
  PractitionerExternalFormProps
> = ({ onValidChange, showErrors }) => {
  const fields = createExternalFields();

  const onChange = useCallback(
    (
      data: Partial<External>,
      _: FormikErrors<External>,
      hasErrors: boolean,
    ) => {
      if (hasErrors) {
        onValidChange(undefined);
      } else {
        // casting since data is validated
        const result = data as External;

        onValidChange(result);
      }
    },
    [onValidChange],
  );

  return (
    <CrudForm
      title={strings.FormLabelPractitionerExternal}
      fields={fields}
      initialValues={{}}
      onChange={onChange}
      showErrors={showErrors}
      validateOnMount
      showSubmitButton={false}
      hasCard={false}
    />
  );
};
